import React, { useState } from 'react';

const Asentamientos = ({ formData, setFormData }) => {
  const colonias = [
    "Mérida Centro","Itzaes","Madrid","Villa Fontana","La Quinta","Los Cocos","Privada Del Maestro","Jardines de San Sebastian","Los Reyes","Alcalá Martín",
    "Yucatán","Señorial","Carrillo Ancona","Inalámbrica","Dolores Patron","Garcia Gineres","El Pedregal",
    "La Huerta",
    "Santa Cecilia",
    "Cupules",
    "Lourdes",
    "Waspa",
    "Itzimna",
    "Itzimna",
    "Itzimna 2",
    "Rinconada Itzmina",
    "Manola",
    "Las Arboledas",
    "Ferrocarrileros",
    "Jesús Carranza",
    "Revolución (Cordemex)",
    "Montebello",
    "San Antonio",
    "Xaman-Tan",
    "Monte Alban",
    "Residencial Sol Campestre",
    "Sodzil Norte",
    "Montes de Ame",
    "Gonzalo Guerrero",
    "Residencial Montejo Norte",
    "Ampliación Revolución",
    "Residencial San Angelo",
    "San Antonio Cucul",
    "Privada San Antonio Cucul",
    "San Ramon Norte",
    "San Ramon Sur",
    "San Ramon Norte I",
    "Villareal",
    "Xaman-Kab",
    "Plan de Ayala",
    "Villas Del Sol",
    "Ampliación Plan de Ayala (Villas del Sol)",
    "Benito Juárez Nte",
    "Villas La Hacienda",
    "Gonzalo Guerrero",
    "Villas del Rey",
    "Campestre",
    "Del Norte",
    "Tecnológico",
    "Ampliación del Norte (1a. Ampliación)",
    "México",
    "Privada Nuevo México",
    "Buenavista",
    "Montejo",
    "México Norte",
    "Privada Mediterráneo",
    "Residencial Colonia México",
    "Emiliano Zapata Nte",
    "Torremolinos",
    "Díaz Ordaz",
    "San Carlos",
    "Vista Alegre",
    "Residencial Palmerales de Altabrisa",
    "Missan II",
    "Residencial Altabrisa",
    "Montecarlo",
    "Vista Alegre",
    "Vista Alegre Norte",
    "Altabrisa",
    "San Remo",
    "Santa Rita Cholul",
    "Montecristo",
    "Montevideo",
    "Residencial Camara de Comercio Norte",
    "Monterreal",
    "Maya",
    "Paraíso Maya",
    "José María Iturralde",
    "Jardines de Mérida",
    "Felipe Carrillo Puerto Nte",
    "México Oriente",
    "Jardines del Noreste",
    "Los Álamos",
    "Residencial Del Arco",
    "La Florida",
    "Los Pinos",
    "Jardines Del Norte",
    "Jardines de Vista Alegre",
    "Residencial Bancarios",
    "San Pedro Cholul",
    "Santa Maria",
    "El Arco",
    "Jardines de Vista Alegre II",
    "Vista Alegre Lotificacion",
    "Pinos Norte II",
    "Prado Norte",
    "San Antonio Cinta",
    "Jardines del Norte de Prado Norte",
    "López Mateos",
    "San Luis",
    "San Miguel",
    "Unidad Habitacional CTM",
    "Antonia Jiménez Trava",
    "Antonia Jiménez Trava II",
    "San Vicente Oriente (La Isla)",
    "Polígono 108",
    "Vicente Guerrero",
    "Boulevares de Oriente",
    "Itzimna 108",
    "Luis Donaldo Colosio",
    "Leandro Valle",
    "Brisas Del Bosque",
    "Emiliano Zapata Ote",
    "Las Brisas",
    "Las Brisas Del Norte",
    "Ampliación las Brisas",
    "Las Palmas",
    "Pet-kanche",
    "San Juan Grande",
    "Noria II",
    "Nueva Alemán",
    "Las Flores",
    "Nuevo Yucatán",
    "San Nicolás",
    "Miguel Alemán",
    "San Esteban",
    "Industrial",
    "Trava Quintero",
    "Fenix",
    "Lourdes Industrial",
    "Los Reyes",
    "Lázaro Cárdenas Ote",
    "Nueva Mayapan",
    "Chuminopolis",
    "Máximo Ancona",
    "Manuel Ávila Camacho",
    "Mayapan",
    "Nueva Pacabtun",
    "Nueva Mayapan",
    "Lotificacion las Brisas",
    "Del Parque",
    "Pacabtun",
    "Manuel Ávila Camacho",
    "Privada Del Autotransporte CTM",
    "Melchor Ocampo",
    "Melchor Ocampo II",
    "Fidel Velázquez",
    "Salvador Alvarado Oriente",
    "Fidel Velázquez 2a Etapa",
    "Emilio Portes Gil",
    "Bosques de Oriente",
    "Privada Emilio Portes Gil",
    "Del Carmen",
    "Cortés Sarmiento",
    "Jardines de Miraflores",
    "Cerillera",
    "Esperanza",
    "Wallis",
    "Chichen-itza",
    "Nueva Chichen-itza",
    "Vergel",
    "Vergel II",
    "Vergel III",
    "Vergel IV",
    "San José Vergel",
    "Real San José",
    "Misne III",
    "Villas La Macarena",
    "Morelos Oriente",
    "Amalia Solorzano",
    "Misné II",
    "San Pablo Oriente",
    "Vergel 65",
    "San Antonio Kaua",
    "El Vergel",
    "Azcorra",
    "Benito Juárez Ote",
    "Miraflores",
    "Privada Miraflores",
    "Vicente Solís",
    "Canto",
    "San José",
    "Morelos",
    "Morelos Issste Fovissste",
    "Nueva Kukulkan",
    "San Antonio Kaua",
    "San Antonio Kaua II",
    "Miraflores II",
    "San Antonio Kaua I",
    "Aquaparque",
    "Salvador Alvarado Sur",
    "Militar",
    "Salvador Alvarado Sur II",
    "Ampliación Salvador Alvarado Sur",
    "Ampliación Granjas",
    "Reparto Granjas",
    "Kukulcan",
    "Maria Luisa",
    "Cordeleros de Chuburna",
    "El Prado",
    "San Pedro Uxmal",
    "Tulias de Chuburna",
    "Arcos del Sol",
    "Aurea Residencial",
    "Arekas",
    "Brisas de Chuburna",
    "Camara de La Construcción",
    "Cocoteros",
    "Del Bosque",
    "El Conquistador",
    "San Pablo",
    "Terranova",
    "Villas Palma Real",
    "Villas Del Prado",
    "Vista Alegre de Chuburna",
    "Privada Chuburna de Hidalgo (II)",
    "Privada Chuburna Plus",
    "Privada Palma Caribeña",
    "Francisco de Montejo",
    "San José Chuburna",
    "Magnolias",
    "Rincón Colonial",
    "Puesta del Sol",
    "Las Haciendas III",
    "La Castellana",
    "Privada Corozal",
    "Ampliación Francisco de Montejo",
    "Francisco de Montejo II",
    "Francisco de Montejo III",
    "Francisco de Montejo IV",
    "Francisco de Montejo V",
    "Platino",
    "Xcumpich",
    "Vía Montejo",
    "Residencial Piedrasul",
    "Residencial Galerias",
    "Revolución",
    "Residencial Hacienda Real",
    "Chuburna de Hidalgo",
    "Bugambilias",
    "El Cortijo I",
    "El Cortijo II",
    "Juan B Sosa",
    "Loma Bonita Xcumpich",
    "Residencial La Noria",
    "Callejones de Chuburna",
    "Las Hadas",
    "Boulevares de Chuburna",
    "Chuburna Inn",
    "El Campanario",
    "San Ángel",
    "Chuburna de Hidalgo (La Floresta)",
    "Las Dalias II",
    "Tabachines",
    "Villas Chuburna IV",
    "Paraíso",
    "San Luis Chuburna",
    "Pinzon",
    "Privada las Flores",
    "Privada Chuburna de Hidalgo I",
    "Privada Pedregal II",
    "Privada Arboledas",
    "Arboledas Chuburna",
    "Privada Campestre Chuburna",
    "Privada San Ángel Chuburna",
    "Loma Bonita",
    "El Rosario",
    "San Francisco Chuburna",
    "San Francisco Chuburna II",
    "San José I",
    "San José II",
    "Mérida (Elefante Grande)",
    "San Vicente Chuburna",
    "Privada Cipreses",
    "Residencial Turquesa",
    "Villas de Yucalpeten",
    "Malaga",
    "Rinconada de Chuburna",
    "Residencial Atlantis",
    "El Cedral",
    "Felipe Carrillo Puerto",
    "Las Quintas (Chuburna)",
    "Privada Chuburna de Hidalgo",
    "Jardines de Chuburna",
    "Privada San Jorge (Chuburna)",
    "Tanlum",
    "Joaquín Ceballos Mimenza",
    "Pedregales de Tanlum",
    "Colonial Buenavista",
    "Colonial Chuburna",
    "Águilas Chuburna",
    "Fovissste",
    "Residencial Pensiones I y II",
    "Francisco El Porvenir",
    "Residencial Pensiones III",
    "Residencial Pensiones IV",
    "Residencial Pensiones V",
    "Residencial Pensiones VI",
    "Residencial Pensiones III (1)",
    "Residencial Pensiones III (II)",
    "Pensiones Norte",
    "Roma",
    "San Damián",
    "Residencial Roma",
    "San Isidro",
    "Conjunto los Naranjos",
    "Lotificacion San Damián",
    "Privada San Damián",
    "Francisco Villa",
    "Lindavista",
    "Limones",
    "Privada Pensiones",
    "San Damiancito",
    "Jardines de Pensiones",
    "Residencial del Norte",
    "Amapola",
    "Lindavista II",
    "Jardines de Lindavista",
    "Lotificacion San Damiancito I",
    "Lotificacion San Damiancito II",
    "Quinta Versalles",
    "Unidad Habitacional Mérida Issste",
    "Residencial Pensiones VII",
    "Paseos de Pensiones",
    "Pensiones",
    "Ampliación Lindavista (Elefante Chico)",
    "Paseos de Chenku",
    "Pedregal de Lindavista",
    "Nueva Hidalgo",
    "La Vaca Feliz",
    "Miguel Hidalgo",
    "Zona Dorada",
    "Atlántida",
    "Paseo de las Fuentes",
    "Privada San Pedro",
    "El Porvenir",
    "Jacinto Canek",
    "Las Vigas",
    "Luis Echeverría Álvarez",
    "15 de Mayo",
    "Hacienda San Antonio",
    "Xcom",
    "Zona Dorada II",
    "Villa Zona Dorada",
    "Ampliación Roma (Luis Echeverría)",
    "Hacienda Inn",
    "Bojorquez",
    "Armando Ávila Gurrutia",
    "Central de Abasto",
    "Nora Quintana",
    "Yucalpeten",
    "Villas de Yucalpeten",
    "Residencial Casa Blanca",
    "Brisas del Poniente (Yucalpeten)",
    "Jardines de Yucalpeten",
    "Yucalpeten Secc Florida",
    "Francisco I Madero",
    "López Portillo",
    "Xoclan Canto",
    "Xoclan Santos",
    "Juan Pablo II Secc. Mérida 2000",
    "Bosques del Poniente",
    "Jardines de Nueva Mulsay",
    "La Reja",
    "Mulsay",
    "Mulsay de La Magdalena",
    "Xoclan",
    "Xoclan Xbech",
    "Juan Pablo II Cardenales",
    "Juan Pablo II",
    "México Poniente",
    "Xoclan Carmelitas",
    "Bosques de Mulsay",
    "Granja Fruticola Susula",
    "Mulsay Solidaridad",
    "Hacienda Mulsay",
    "Ampliación Juan Pablo II",
    "Paseos de Opichen",
    "Villas de Tixcacal",
    "Los Ángeles",
    "Ágeles II",
    "Anexo Juan Pablo II",
    "San Lorenzo",
    "Mulsay",
    "Nueva Mulsay",
    "Nueva Mulsay I",
    "Plantel México",
    "Pedregales de Nueva Mulsay Etapa",
    "Xoclan Susula",
    "Jardines de Nueva Mulsay II",
    "Nueva Reforma Agraria",
    "Tixcacal Opichen",
    "Villa Magna",
    "Cinturón Verde",
    "Villa Magna II",
    "Ampliación Tixcacal Opichen",
    "Hacienda Opichen",
    "Jardines de Nueva Mulsay III",
    "Núcleo Mulsay",
    "Girasoles de Opichen",
    "Hacienda Opichen",
    "Residencial Valparaiso",
    "Diamante Paseos de Opichen",
    "Nueva Sambula",
    "Sambula",
    "Bicentenario",
    "El Roble",
    "Manuel Crescencio Rejon",
    "El Roble II",
    "Roble Agrícola III",
    "Álvaro Torres",
    "Graciano Ricalde",
    "Libertad II",
    "Villas Mérida",
    "Libertad III",
    "Lol-Be",
    "Residencial Nicte",
    "Obrera",
    "Villa de la Obrera II",
    "Villas del Mayab",
    "Nueva Obrera",
    "Bosques del Pedregal",
    "Circuito Colonias",
    "Villa Moderna",
    "Manzana 115",
    "Delio Moreno Canton",
    "Quinta Valencia",
    "Meliton Salazar",
    "Santa Maria de Guadalupe",
    "Renacimiento I",
    "Dolores Otero",
    "Mercedes Barrera",
    "Castilla Camara",
    "Santa Rosa",
    "Quinta Santa Rosa",
    "Cinco Colonias",
    "Santa Rita",
    "Lomas Del Sur",
    "Lindavista",
    "Bellavista",
    "Serapio Rendón",
    "San José Tzal",
    "Villa Bonita",
    "Ampliación Plan de Ayala",
    "Haltunchén",
    "Plan de Ayala Sur",
    "Serapio Rendón III",
    "Villas Del Sur",
    "San Carlos del Sur",
    "Villa Magna del Sur",
    "Jardines del Sur",
    "Álamos del Sur",
    "Plan de Ayala Sur III",
    "Serapio Rendón II",
    "Las Nubes",
    "Palmas del Sur",
    "Las Brisas Del Sur",
    "Del Sur",
    "Ciudad Industrial",
    "Industrial Bridec",
    "La Hacienda",
    "San Nicolás Del Sur",
    "San Antonio Xluch",
    "Nueva San José Tecoh",
    "San Antonio Xluch II",
    "La Guadalupana",
    "Mérida (Licenciado Manuel Crescencio Rejón)",
    "San Marcos",
    "Gran Roble",
    "El Roble Agrícola",
    "Santa Cruz",
    "San Marcos Nocoh",
    "Villas Quetzal",
    "Emiliano Zapata Sur",
    "El Rosal",
    "San Luis Sur",
    "Metropolitana",
    "San Antonio Xluch III",
    "Zacilha",
    "San José Tecoh Sur",
    "Privada Zuzil - Ha",
    "Zazil - Ha II",
    "Brisas de San José",
    "San José Tecoh",
    "Los Tamarindos",
    "Residencial Xcanatún",
    "Royal del Parque",
    "Chablekal",
    "Komchén",
    "Xcanatún",
    "Dzidzilché",
    "Sierra Papacal",
    "Piedra Antigua",
    "Palmequén",
    "Xotik",
    "San Antonio Residencial",
    "Residencial La Alborada",
    "Residencial Club Norte Mérida",
    "San Antonio Hool",
    "Real de Dzityá",
    "Punta Lago",
    "Parque Industrial Yucatán",
    "San Juan Bautista",
    "Kinich",
    "Soluna",
    "Katna",
    "Oasis del Norte",
    "Solasta",
    "Dzityá",
    "Sac-Nicté",
    "Temozón Norte",
    "Club de Golf La Ceiba",
    "Las Américas",
    "Real Montejo",
    "Residencial del Mayab",
    "Las Fincas",
    "Núcleo Sodzil",
    "Cosgaya",
    "Kikteil",
    "Noc Ac",
    "Cheumán",
    "Xcunyá",
    "Tamanché",
    "Residencial Campestre Viladiu",
    "Gran San Pedro Cholul",
    "Villas Cholul",
    "Bogdan",
    "San Luis Cholul",
    "Cholul",
    "Parque Central",
    "Sian Kaan",
    "Residencial Anturio",
    "Altavista",
    "Granjas Cholul",
    "Alura",
    "Tixcuytún",
    "Villas del Bosque Cholul",
    "San Gabriel Tulipanes",
    "Cabo Norte",
    "Parque Natura",
    "El Triunfo",
    "Porto Belo",
    "Porto Alegre",
    "Porto Novo",
    "Allegra",
    "Arborettos",
    "Návita Residencial",
    "Manantiales",
    "Fontana",
    "Trinum",
    "Álamo",
    "Piedraverde",
    "Julieta",
    "Aldoria",
    "Vida Verde",
    "Oasis Residencial Cholul",
    "Cúspide",
    "La Rua",
    "Lunare Privada",
    "San Javier Tulipanes",
    "Palta",
    "Amanta",
    "Fiora Residencial",
    "Santa Gertrudis Copo",
    "Algarrobos Desarrollo Residencial",
    "Las Margaritas de Cholul",
    "Dzibilchaltún",
    "Cocoyoles",
    "Jalapa",
    "Chichi Suárez",
    "Sitpach",
    "Residencial Floresta",
    "Punta Esmeralda",
    "Santa María Chí",
    "Los Héroes",
    "La Rejoyada",
    "Jardines de Rejoyada",
    "Komchén (Santuario)",
    "Santa María Yaxché",
    "Yucatán Country Club",
    "Misnébalam",
    "Universidad del Mayab",
    "Yaxché Casares",
    "Oncán",
    "Los Faisanes de Tixcacal",
    "Solana Residencial",
    "Providencia",
    "Tixcacal",
    "Chalmuch",
    "Balcones II",
    "Ciudad Caucel II",
    "Hogares Caucel",
    "Caucel",
    "Cerradas de la Herradura",
    "Villa Jardín",
    "La Ceiba",
    "La Perla Ciudad Caucel",
    "Gran Herradura",
    "La Ciudadela",
    "Piedra Norte Caucel",
    "Sian Kaan II",
    "Sian Kaan",
    "Sian Kaan IV",
    "Sol Caucel",
    "Jardines de Caucel",
    "Susulá",
    "Los Balcones",
    "Los Almendros",
    "Villas de Caucel",
    "Boulevares",
    "Arboleda",
    "Las Torres I",
    "Pedregales de Ciudad Caucel",
    "La Herradura II",
    "Gran Santa Fe",
    "Las Torres",
    "Viva Caucel",
    "Hacienda Caucel",
    "La Herradura III",
    "Las Torres II",
    "Centenario Cámara de Comercio Caucel",
    "Sol Caucel III",
    "Ciudad Caucel",
    "Nuevo San José Tecoh III",
    "Dzununcán",
    "Molas",
    "San José Tzal",
    "Tahdzibichén",
    "San Antonio Tzacalá",
    "Dzununcan",
    "Hunxectamán",
    "Jardines de Tahdzibichén",
    "San Pedro Chimay",
    "Texán Cámara",
    "Santa Cruz Palomeque",
    "Xmatkuil",
    "La Guadalupana",
    "Nuevo San José Tecoh",
    "Petac",
    "Dzoyaxché",
    "San Ignacio Tesip",
    "Yaxnic"
  ];

  // Función para normalizar cadenas (remover acentos)
  const normalizeStr = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  };

  const [searchTerm, setSearchTerm] = useState(formData.colonia || '');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const filteredColonias = colonias.filter(colonia =>
    normalizeStr(colonia).startsWith(normalizeStr(searchTerm))
  );

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    setShowSuggestions(true);
    setFormData(prevData => ({
      ...prevData,
      colonia: e.target.value
    }));
  };

  const handleSelectSuggestion = (selected) => {
    setSearchTerm(selected);
    setShowSuggestions(false);
    setFormData(prevData => ({
      ...prevData,
      colonia: selected
    }));
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        type="text"
        placeholder="Escribe tu colonia..."
        value={searchTerm}
        onChange={handleChange}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
        style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
      />
      {showSuggestions && searchTerm.trim() !== '' && (
        <ul
          style={{
            position: 'absolute',
            width: '100%',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            margin: 0,
            padding: '5px',
            listStyle: 'none',
            maxHeight: '150px',
            overflowY: 'auto',
            zIndex: 999
          }}
        >
          {filteredColonias.length > 0 ? (
            filteredColonias.map(colonia => (
              <li
                key={colonia}
                onMouseDown={() => handleSelectSuggestion(colonia)}
                style={{
                  padding: '5px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee'
                }}
              >
                {colonia}
              </li>
            ))
          ) : (
            <li style={{ padding: '5px', color: '#999' }}>Sin coincidencias</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Asentamientos;
